const compareStrings = (a, b) =>
  (a ?? "").toString().localeCompare((b ?? "").toString(), undefined, {
    sensitivity: "base",
  });

export const getUniqueCompanyNames = (contacts = []) =>
  Array.from(
    new Set(contacts.map((contact) => contact.company?.name).filter(Boolean)),
  ).sort(compareStrings);

export const getUniqueJobTitles = (contacts = [], normalizeJobTitle) =>
  Array.from(
    new Set(
      contacts
        .map((contact) => normalizeJobTitle(contact.job_title))
        .filter(Boolean),
    ),
  ).sort(compareStrings);

export const sortContactsByColumn = ({
  contacts = [],
  orderBy,
  orderDirection,
  getValue,
}) => {
  const direction = orderDirection === "asc" ? 1 : -1;

  return contacts.slice().sort((a, b) => {
    const result = compareStrings(getValue(a, orderBy), getValue(b, orderBy));
    return result * direction;
  });
};
